import React, { useContext } from 'react';
import SecondaryButton from '../generated/SecondaryButton';
import { Link } from '@mui/material';
import { NavigationContext } from '../../context/NavigationContext';

const BackButton = (props) => {
  const context = useContext(NavigationContext)
  
  return (
    <div className="back-button-wrapper">
      <Link className="navigation-link" onClick={() => {
        context.goBack();
      }}>
        <SecondaryButton {...props}>
          <img className="back-button-circle" src="/img/down_arrow.svg" />
        </SecondaryButton>
        <label className="navigation-label">Back</label>
      </Link>
    </div>
)}


export default BackButton;
